import moment from "moment";
class concept {
  constructor(id, name, licTot, horTrab, redondeaLiq, cat, ws, denegarAcceso) {
    this.id = id;
    this.name = name;
    this.licTot = licTot;
    this.horTrab = horTrab;
    this.redondeaLiq = redondeaLiq;
    this.cat = cat;
    this.ws = ws;
    this.denegarAcceso = denegarAcceso;
  }
  static fromJson({
    conceptoId,
    nombre,
    licTot,
    horTrab,
    redondeaLiq,
    cat,
    ws,
    denegarAcceso,
  }) {
    return new concept(
      conceptoId,
      nombre,
      licTot,
      horTrab,
      redondeaLiq,
      cat,
      ws,
      denegarAcceso
    );
  }
}
export default concept;
